
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDepth as ObiDepthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-depth.js';
 
 
 

 
 export const ObiDepth = createComponent({
   react: React,
   tagName: 'obi-depth',
   elementClass: ObiDepthElement,
   events: {
     
   }
  });
 
 